import http from "./http";

//
export function getShop(data) {
  return http({
    url: "/web/merchant/shop/list",
    method: "GET",
    params: data,
  });
}

export function getOptionList(data) {
  return http({
    url: "/web/platform/shopCountry/optionList",
    method: "GET",
    params: data,
  });
}

export function getShopRegionOptionList() {
  return http({
    url: "/web/platform/shopRegion/optionList",
    method: "GET",
  });
}

export function bindShop(data) {
  return http({
    url: "/web/merchant/shop/bind-shop",
    method: "POST",
    data,
  });
}

export function authShop(data) {
  return http({
    url: "/web/merchant/auth/tiktok-auth",
    method: "POST",
    data,
  });
}

export function delShop(id) {
  return http({
    url: `/web/merchant/shop/${id}`,
    method: "DELETE",
  });
}

export function getShopInfo(id) {
  return http({
    url: `/web/merchant/shop/${id}`,
    method: "GET",
  });
}

export function selectShop(data) {
  return http({
    url: "/web/merchant/shop/selectShop",
    method: "POST",
    data,
  });
}

export function getRolePage() {
  return http({
    url: "/web/merchant/role/page",
    method: "GET",
  });
}

export function getMenuRolePermissions() {
  return http({
    url: "/web/merchant/role/menu-permissions",
    method: "GET",
  });
}

export function createRole(data) {
  return http({
    url: "/web/merchant/role",
    method: "POST",
    data,
  });
}

export function updateRole(id, data) {
  return http({
    url: `/web/merchant/role/${id}`,
    method: "PUT",
    data,
  });
}

export function deleteRole(id) {
  return http({
    url: `/web/merchant/role/${id}`,
    method: "DELETE",
  });
}

export function getSubAccountPage(data) {
  return http({
    url: "/web/merchant/sub-account/page",
    method: "GET",
    params: data,
  });
}

export function updateSubAccountStatus(id, data) {
  return http({
    url: `/web/merchant/sub-account/${id}/status`,
    method: "PUT",
    params: data,
  });
}

export function createSubAccount(data) {
  return http({
    url: "/web/merchant/sub-account/create",
    method: "POST",
    data,
  });
}

export function removeSubAccount(id) {
  return http({
    url: `/web/merchant/sub-account/${id}/remove`,
    method: "DELETE",
  });
}

export function getSubAccountShopRoles(id, data) {
  return http({
    url: `/web/merchant/sub-account/${id}/shop-roles`,
    method: "POST",
    data,
  });
}

export function getUserGoodsUsageByMetricCode(data) {
  return http({
    url: "/web/merchant/goods-usage/getUserGoodsUsageByMetricCode",
    method: "POST",
    data,
  });
}

export function creatorAuth(data) {
  return http({
    url: "/web/merchant/shop-creator-auth/creator-auth",
    method: "POST",
    data,
  });
}

export function creatorCancel(data) {
  return http({
    url: "/web/merchant/shop-creator-auth/creator-cancel",
    method: "POST",
    data,
  });
}

export function getCreatorAuthPage(data) {
  return http({
    url: "/web/merchant/shop-creator-auth/page",
    method: "POST",
    data,
  });
}

export function getAuthRecordPage(data) {
  return http({
    url: "/web/merchant/auth-record/tiktok-auth-record",
    method: "POST",
    data,
  });
}

export function resetSubAccountPassword(id, data) {
  return http({
    url: `/web/merchant/sub-account/${id}/reset-password`,
    method: "PUT",
    data,
  });
}
